import { useDrag } from 'react-dnd'
import { LibraryElementTypes } from 'src/editor/enums/libraryElementTypes'
import { twMerge } from 'tailwind-merge'

const BASE_CLASS =
  'group border-text-secondary/30 hover:border-brand-primary main-transition-colors flex h-[120px] w-[100px] flex-col items-center justify-evenly gap-3 rounded-lg border p-1 bg-background-secondary'

interface LibraryItemDraggableProps {
  children: React.ReactNode
  type: keyof typeof LibraryElementTypes
}

export const LibraryItemDraggable = ({ children, type }: LibraryItemDraggableProps) => {
  const [, dragRef] = useDrag({
    item: { type },
    type,
  })
  return (
    <div
      // https://github.com/react-dnd/react-dnd/issues/788#issuecomment-367300464
      style={{ transform: 'translate(0, 0)' }}
      ref={dragRef}
      className={twMerge(BASE_CLASS, 'cursor-move')}
    >
      {children}
    </div>
  )
}

interface LibraryItemProps {
  children: React.ReactNode
  onClick?: () => void
}

export const LibraryItem = ({ children, onClick }: LibraryItemProps) => {
  return (
    <button className={BASE_CLASS} onClick={onClick}>
      {children}
    </button>
  )
}
